import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core'
import { TOW_LOCATION_ACTIONS, LocationActionButton } from '../../location/location.types'
import { AdobeEventService } from '../../tagging/adobe/event-adobe.service'
import events from '../../tagging/events'
import { AdobeEventTypes } from '../../tagging/tagging.types'
import { IonActionSheet } from '@ionic/angular'

@Component({
  selector: 'drr-tow-location-actions',
  templateUrl: './tow-location-actions.component.html',
  styleUrls: ['./tow-location-actions.component.scss'],
})
export class TowLocationActionsComponent implements OnDestroy {
  @Input() isEV: boolean
  @Input() isOpen: boolean
  @Output() isOpenChange = new EventEmitter<boolean>()
  @Output() actionSelected = new EventEmitter<TOW_LOCATION_ACTIONS>()
  @ViewChild('actionSheet') actionSheet: IonActionSheet

  constructor(
    private adobeEventService: AdobeEventService,
  ) {}

  ngOnDestroy() {
    if (this.actionSheet) {
      this.actionSheet.dismiss()
    }
  }

  handleAction(event: CustomEvent) {
    this.isOpenChange.emit(false)
    if (!event.detail.data || event.detail.data.action === 'cancel') {
      return
    }
    this.actionSelected.emit(event.detail.data.action)
    this.adobeEventService.sendEvent({
      eventValue: event.detail.data.eventValue,
      eventName: AdobeEventTypes.CTA
    })
  }

  towActions = (): LocationActionButton[] => [
    {
      text: $localize`Find Facilities Near Me`,
      ...(!this.isEV ? {
        icon: 'assets/drrweb-lib/images/icons/member-discount.svg',
        cssClass: 'tow-location-actions-icon',
      } : {}),
      data: {
        action: TOW_LOCATION_ACTIONS.FIND_NEAR_ME,
        eventValue: events.towTo.DESTINATION_ACTION_NEAR_ME,
      },
    },
    {
      text: $localize`Find Facilities Near an Address`,
      ...(!this.isEV ? {
        icon: 'assets/drrweb-lib/images/icons/member-discount.svg',
        cssClass: 'tow-location-actions-icon',
      } : {}),
      data: {
        action: TOW_LOCATION_ACTIONS.FIND_NEAR_ADDRESS,
        eventValue: events.towTo.DESTINATION_ACTION_NEAR_LOCATION,
      },
    },
    {
      text: $localize`Tow To a Specific Address`,
      data: {
        action: TOW_LOCATION_ACTIONS.TOW_SPECIFIC_ADDRESS,
        eventValue: events.towTo.DESTINATION_ACTION_CUSTOM,
      },
    },
    {
      text: $localize`Cancel`,
      role: 'cancel',
      data: {
        action: 'cancel',
      },
    },
  ]
}
